module.exports = __webpack_public_path__ + "static/media/Tisn BTL.b6ff47b3.JPG";